import TopBar from "../../components/Layout/TopBar";
import React, {useEffect, useState} from "react";
import ClipLoader from "react-spinners/ClipLoader";
import {useAlert} from 'react-alert';
import useAuthz from "../../hooks/useAuthz";
import {useNavigate} from 'react-router';
import axios from "axios";
import {URL_API} from "../../utils/globalConfig";
import {logError} from "../../components/Utils/FormatData";
import FormLabel from "@mui/material/FormLabel";
import {Autocomplete, Button, Checkbox, FormControl, Grid, List, ListItem, ListItemIcon, ListItemText, Paper, TextField} from "@mui/material";
import MyButton from "../../components/Layout/MyButton";
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const centresStyle = {
  row: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'center'
  },
  stat: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  title: {
    fontSize: '22px',
    margin: '5px'
  },
  value: {
    fontWeight: 'bold',
    fontSize: '40px',
    margin: '5px',
    color: '#0094ca'
  },
  textField: {
    width: '50%',
    margin: '20px'
  },
  container: {
    padding: '15px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  legendGrid: {
    fontFamily: 'GADUGI',
    fontSize: '16px'
  }
}
function not(a, b) {
  return a.filter((value) => b.indexOf(value) === -1);
}
function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

const Centres = (props) => {
  const alert = useAlert();
  const navigate = useNavigate();
  const [authz, user, profil] = useAuthz();
  const [isLoading, setIsLoading] = useState(true);
  const [centres, setCentres] = useState([]);
  const [centerSelected, setCenterSelected] = useState(null);
  const [listUsers, setListUsers] = useState([]);
  const [usersNotAffected, setUsersNotAffected] = useState([]);
  const [usersAffectedToCenter, setUsersAffectedToCenter] = useState([]);
  const [checked, setChecked] = useState([]);
  const [codeLocalisation, setCodeLocalisation] = useState(null);
  const [costCenter, setCostCenter] = useState(null);
  const leftChecked = intersection(checked, usersNotAffected);
  const rightChecked = intersection(checked, usersAffectedToCenter);

  useEffect(() => {
    if (profil.profil === 6) {
      alert.error(`Vous n'êtes pas autorisé à accéder à la blacklist`);
      navigate('/');
    }
    document.title = 'TE - Gestion des centres';
    apiGetListUsers();
    apiGetListCenters();
  }, []);
  useEffect(() => {
    if (centerSelected !== null) {
      apiGetUsersByCenter();
      setCodeLocalisation(centerSelected.code_localisation);
      setCostCenter(centerSelected.cost_center);
    } else {
      setUsersAffectedToCenter([]);
      setCodeLocalisation(null);
      setCostCenter(null);
      setUsersNotAffected(listUsers)
    }
  }, [centerSelected]);

  // API
  const apiGetListCenters = () => {
    setIsLoading(true);
    axios({method: 'get', url: `${URL_API}/localisation/list-centers`})
      .then(function (response) {
        setCentres(response.data);
        setIsLoading(false);
      })
      .catch(function (err) {
        logError(alert, err);
        setIsLoading(false);
      });
  };
  const apiGetListUsers = () => {
    setIsLoading(true);
    axios({method: 'get', url: `${URL_API}/utilisateur/liste`, params: {deleted: "false"}})
      .then(function (response) {
        setListUsers(response.data);
        setIsLoading(false);
      })
      .catch(function (err) {
        logError(alert, err);
        setIsLoading(false);
      });
  }
  const apiGetUsersByCenter = () => {
    setIsLoading(true);
    axios({method: 'get', url: `${URL_API}/localisation/users-by-center`, params: {idCenter: centerSelected.id}})
      .then(function (response) {
        setUsersAffectedToCenter(response.data);
        setUsersNotAffected(returnNotAffectedUsers(response.data));
        setIsLoading(false);
      })
      .catch(function (err) {
        logError(alert, err);
        setIsLoading(false);
      });
  }
  const apiSaveCenterCode = () => {
    setIsLoading(true);

    axios({method: 'put', url: `${URL_API}/localisation/update-code?idCenter=${centerSelected.id}&codeLocalisation=${codeLocalisation}&costCenter=${costCenter}`})
      .then(function () {
        setIsLoading(false);
        centerSelected.code_localisation = codeLocalisation;
        centerSelected.cost_center = costCenter;
        alert.removeAll();
        alert.success(`Les codes du centre technique [${centerSelected.label}] ont bien été mise à jour`);
      })
      .catch(function (err) {
        logError(alert, err);
        setIsLoading(false);
      });
  }

  const apiUpdateUsersToCenter = (usersList) => {
    setIsLoading(true);

    axios({method: 'put', url: `${URL_API}/localisation/update-users-to-center?idCenter=${centerSelected.id}`, data: usersList})
      .then(function () {
        setCenterSelected(null);
        setIsLoading(false);
        alert.removeAll();
        alert.success(`Les utilisateurs affectés au centre technique [${centerSelected.label}] ont bien été mise à jour`);
      })
      .catch(function (err) {
        logError(alert, err);
        setIsLoading(false);
      });
  }

  // Gestion du changement de centre
  const handleChangeSelectedCenter = (newCenter) => {
    setCenterSelected(newCenter);
  };
  const validUsersAffectedToCenter = () => {
    const usersIdList = [];

    for (const aUser of usersAffectedToCenter) {
      usersIdList.push({userId: aUser.user_id, centerId: centerSelected.id})
    }

    apiSaveCenterCode();
    apiUpdateUsersToCenter(usersIdList);
  }

  // Gestion des utilisateurs
  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };
  const handleAllRight = () => {
    setUsersAffectedToCenter(usersAffectedToCenter.concat(usersNotAffected));
    setUsersNotAffected([]);
  };
  const handleCheckedRight = () => {
    setUsersAffectedToCenter(usersAffectedToCenter.concat(leftChecked));
    setUsersNotAffected(not(usersNotAffected, leftChecked));
    setChecked(not(checked, leftChecked));
  };
  const handleCheckedLeft = () => {
    setUsersNotAffected(usersNotAffected.concat(rightChecked));
    setUsersAffectedToCenter(not(usersAffectedToCenter, rightChecked));
    setChecked(not(checked, rightChecked));
  };
  const handleAllLeft = () => {
    setUsersNotAffected(usersNotAffected.concat(usersAffectedToCenter));
    setUsersAffectedToCenter([]);
  };
  const customList = (items) => (
    <Paper sx={{width: '25vw', height: 400, overflow: 'auto'}}>
      <List dense component="div" role="list">
        {items.map((value, i) => {
          const labelId = `item-user-${i}`;

          return (
            <ListItem
              key={`user-` + value.user_id}
              role="listitem"
              button
              onClick={handleToggle(value)}
            >
              <ListItemIcon>
                <Checkbox
                  checked={checked.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{
                    'aria-labelledby': labelId,
                  }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={`${value.nom === null && value.prenom === null ? value.raison_sociale : value.nom + ' ' + value.prenom}`}/>
            </ListItem>
          );
        })}
        <ListItem/>
      </List>
    </Paper>
  );

  // Suppression des utilisateurs déjà affectés
  const returnNotAffectedUsers = (affectedUsers) => {
    const usersNotAffectedToSelectedCenter = [];

    for (const anUser of listUsers) {
      if (affectedUsers.filter((value) => value.user_id === anUser.user_id).length === 0) {
        usersNotAffectedToSelectedCenter.push(anUser);
      }
    }

    return usersNotAffectedToSelectedCenter;
  }

  return (
    <div style={{height: 'calc(100% - 50px)'}}>
      <TopBar title="Gestion des centres" className='topbar-contenu' color={props.params.color}/>
      <div className='row' style={{margin: 0, overflow: 'auto', height: '100%'}}>

        <ClipLoader color='#0094ca' loading={isLoading} size={75} css={'display: flex; margin: 25px;justify-content: center;'}/>
        {!isLoading && (
          <div style={centresStyle.container}>
            <FormControl>
              <FormLabel>Merci de renseigner un centre avant de pouvoir affecter des utilisateurs</FormLabel>
                <Autocomplete
                  options={centres}
                  renderInput={(params) => <TextField {...params} label="Centre"/>}
                  onChange={(e, newCenter) => handleChangeSelectedCenter(newCenter)}
                  getOptionLabel={(option) => option.label}
                  value={centerSelected}
                />
            </FormControl>

            {
              centerSelected !== null &&
              <>

                <div style={{display: 'flex'}}>
                  <TextField
                    label="Code localisation"
                    value={codeLocalisation || ''}
                    onChange={(e) => setCodeLocalisation(e.target.value)}
                  />

                  <TextField
                    label="Coût centre"
                    value={costCenter || ''}
                    onChange={(e) => setCostCenter(e.target.value)}
                  />
                </div>

                <Grid container spacing={5} justifyContent="center" alignItems="center">
                  <Grid item><p style={centresStyle.legendGrid}>Utilisateur(s) disponible(s)</p>{customList(usersNotAffected)}</Grid>
                  <Grid item>
                    <Grid container direction="column" alignItems="center">
                      <Button
                        sx={{my: 0.5}}
                        variant="outlined"
                        size="small"
                        onClick={handleAllRight}
                        disabled={usersNotAffected.length === 0}
                        aria-label="move all right"
                      >
                        ≫
                      </Button>
                      <Button
                        sx={{my: 0.5}}
                        variant="outlined"
                        size="small"
                        onClick={handleCheckedRight}
                        disabled={leftChecked.length === 0}
                        aria-label="move selected right"
                      >
                        &gt;
                      </Button>
                      <Button
                        sx={{my: 0.5}}
                        variant="outlined"
                        size="small"
                        onClick={handleCheckedLeft}
                        disabled={rightChecked.length === 0}
                        aria-label="move selected left"
                      >
                        &lt;
                      </Button>
                      <Button
                        sx={{my: 0.5}}
                        variant="outlined"
                        size="small"
                        onClick={handleAllLeft}
                        disabled={usersAffectedToCenter.length === 0}
                        aria-label="move all left"
                      >
                        ≪
                      </Button>
                    </Grid>
                  </Grid>
                  <Grid item><p style={centresStyle.legendGrid}>Utilisateur(s) affecté(s)</p>{customList(usersAffectedToCenter)}</Grid>
                </Grid>
                <div className='row' style={{height: 'auto', justifyContent: 'flex-end', marginTop: '15px'}}>
                  <MyButton style="buttonValidation" label="Enregister" icon={faCheck} onClick={() => validUsersAffectedToCenter()}/>
                </div>
              </>
            }
          </div>
        )}
      </div>
    </div>
  );

}

export default Centres;
